"use client";

import { useEffect, useState } from "react";

import {
  GAM_HOME_TABLET_BANNER_AD_UNIT,
  GAM_HOME_TABLET_BANNER_ENABLED,
  GAM_HOME_TABLET_BANNER_MIN_HEIGHT,
  GAM_HOME_TABLET_BANNER_SIZES,
} from "@/components/ads/config";

import GamDisplaySlot from "./GamDisplaySlot";
import styles from "./HomeTabletBannerAd.module.css";

const TABLET_QUERY = "(min-width: 768px) and (max-width: 1199px)";

export default function HomeTabletBannerAd() {
  const [isTablet, setIsTablet] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(TABLET_QUERY);

    const update = () => {
      setIsTablet(mediaQuery.matches);
    };

    update();
    mediaQuery.addEventListener("change", update);

    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  if (!GAM_HOME_TABLET_BANNER_ENABLED || isTablet !== true) return null;

  return (
    <div className={styles.wrap} data-premium-tablet-ad="home_tablet_banner">
      <div className={styles.inner}>
        <div className={styles.header}>
          <span className={styles.label}>Sponsored</span>
        </div>

        <GamDisplaySlot
          id="home-tablet-banner"
          adUnit={GAM_HOME_TABLET_BANNER_AD_UNIT}
          sizes={[...GAM_HOME_TABLET_BANNER_SIZES]}
          minHeight={GAM_HOME_TABLET_BANNER_MIN_HEIGHT}
          targeting={{
            page_type: "home",
            device: "tablet",
            placement: "home_tablet_banner_before_base_selector",
            position: "before_base_selector",
          }}
        />
      </div>
    </div>
  );
}
